
import React from "react";
import "./miniCalendarSkeleton.css";

const MiniCalendarSkeleton = () => {
	return (
		<div className="sf-week-skeleton">
			<div className="sf-week-skel-overlay">
				<div className="sf-week-spinner"></div>
			</div>
		</div>
	);
};

export default MiniCalendarSkeleton;
